import { Injectable, QueryList } from '@angular/core';
import {FormGroup, FormControl} from '@angular/forms';
import {NeqValidationComponent} from '@sharedcommon/components/validation/validation.component';
import {MatDialog} from '@angular/material/dialog';
import {NeqNutrientsTreeDatabase} from '@admincommon/components/nutrients/nutrients-tree-database.model';
import {NeqVariableTreeDatabase} from '@admincommon/components/variables/variable-tree-database.model';
import {NutrimentValueDirective} from '@usercommon/components/rawmaterials-or-samples/rawmaterials-or-samples-values/rawmaterials-or-samples-values.component';

@Injectable()
export class ValidationService {

  /**
   * FormGroup of the current page
   */
  currentForm: FormGroup = null;

  /**
   * For the forms without formgroup we use this value
   */
  dirty = false;

  /**
   * Exception for the nutrition tree, check the modification on this object
   */
  treeData: NeqNutrientsTreeDatabase | NeqVariableTreeDatabase = null;

  /**
   * RawmaterialsValues exceptions
   */
  notes: FormControl = null;
  valueFields: QueryList<NutrimentValueDirective> = null;

  constructor(private readonly dialog: MatDialog) {}

  /**
   * Init the check dirty value
   */
  init(): void {
    this.currentForm = null;
    this.dirty = false;
    this.treeData = null;
    this.notes = null;
    this.valueFields = null;
  }

  /**
   * Determine if the forms, page or tree is modified or not.
   */
  isDirty(): boolean {
    if ( this.notes && this.valueFields ) {
      return this.dirty || this.isRawMaterialsValuesDirty();
    }
    if (this.treeData) {
      return this.treeData.modifiedItems.length > 0;
    }
    return (this.currentForm) ? this.currentForm.dirty : this.dirty;
  }

  isRawMaterialsValuesDirty(): boolean {
    return this.valueFields
      .some((field, _idx, _items) => field.nutrimentValue.dirty) || this.notes.dirty;
  }

  /**
   * Check if the current form or tree as some modification, and show a confirmation popup before redirect if yes
   *
   * @param callback
   */
  checkModifications(callback: Function) {
    if (this.isDirty()) {
      const dialog = this.dialog.open(NeqValidationComponent);
      dialog.afterClosed().subscribe((result: boolean) => {
        if (result) {
          if (callback !== undefined && callback !== null) {
            callback();
          }
        }
      });
    } else {
      callback();
    }
  }
}
